// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3W2fy","select":"Header_select__2XPHa","clinic":"Header_clinic__1za7L"};